import {type FC, useEffect, useRef} from 'react';
import {styled} from 'styled-components';
import {useLocation} from 'wouter';

import {UnthemedNavLink} from '@repo/shared-web/components/core/button';

interface NavBarProps {}

export const NavBar: FC = () => {
  const [location] = useLocation();
  const navRef = useRef<HTMLElement>(null);

  useEffect(() => {
    navRef.current
      ?.querySelector<HTMLElement>('[aria-current="page"]')
      ?.scrollIntoView({block: 'nearest', inline: 'nearest'});
  }, [location]);

  return (
    <Wrapper>
      <NavLinks ref={navRef}>
        <StyledNavLink
          $active={location === '/nzbsu'}
          aria-current={location === '/nzbsu' ? 'page' : undefined}
          to="/nzbsu"
        >
          NZB.su
        </StyledNavLink>
        <StyledNavLink
          $active={location === '/browse'}
          aria-current={location === '/browse' ? 'page' : undefined}
          to="/browse"
        >
          Movies
        </StyledNavLink>
        <StyledNavLink
          $active={location === '/koh-lanta'}
          aria-current={location === '/koh-lanta' ? 'page' : undefined}
          to="/koh-lanta"
        >
          Koh-Lanta
        </StyledNavLink>
      </NavLinks>
    </Wrapper>
  );
};

NavBar.displayName = 'NavBar';

const Wrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  height: 64px;
  flex-shrink: 0;
  background: #1f242f;
  box-shadow: 0px 4px 10px -10px black;
`;

const NavLinks = styled.nav`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
  height: 100%;
  min-width: 0;
  overflow-x: auto;
  @media (max-width: 600px) {
    justify-content: flex-start;
    gap: 4px;
    padding: 0 8px;
  }
`;

const StyledNavLink = styled(UnthemedNavLink)<{$active: boolean}>`
  flex-shrink: 0;
  color: #ffffffcc;
  padding: 8px 16px;
  border-radius: 4px;
  ${p => p.$active && 'background: #ffffff11;'}
  &:hover {
    ${p => !p.$active && 'background: #ffffff05;'}
  }
`;
